
let api = 'https://i9helpdesk-a8541e0fe9d5.herokuapp.com';

let localhost = 'http://localhost:3001'
export const API = api;